import { FiImage, FiUpload, FiX } from 'react-icons/fi';

const RecipeImageUpload = ({ 
  imagePreview, 
  handleImageChange, 
  handleRemoveImage, 
  isSubmitting 
}) => {
  return (
    <div className="border-t pt-4 mt-2">
      <label className="block text-sm font-medium text-gray-700 mb-2">Recipe Image</label>
      <div className="flex flex-col sm:flex-row gap-4 items-start">
        <div className="flex flex-col items-center">
          {imagePreview ? (
            <div className="relative group">
              <img 
                src={imagePreview} 
                alt="Preview" 
                className="h-24 w-24 object-cover rounded-md border-2 border-gray-200"
              />
              <button
                type="button"
                onClick={handleRemoveImage}
                className="absolute -top-2 -right-2 bg-white rounded-full p-1 shadow-sm border border-gray-200 hover:bg-red-100 text-red-500"
                aria-label="Remove image"
                disabled={isSubmitting}
              >
                <FiX size={12} />
              </button>
            </div>
          ) : (
            <div className="h-24 w-24 flex items-center justify-center bg-gray-100 rounded-md border-2 border-dashed border-gray-300">
              <FiImage size={24} className="text-gray-400" />
            </div>
          )}
          <p className="text-xs text-gray-500 mt-1 text-center">Max 2MB</p>
        </div>
        <div className="flex-1 w-full">
          <input
            type="file"
            name="image"
            onChange={handleImageChange}
            accept="image/*"
            className="hidden"
            id="recipe-image-upload"
            disabled={isSubmitting}
          />
          <label
            htmlFor="recipe-image-upload"
            className={`flex items-center justify-center gap-2 w-full px-4 py-3 border border-gray-300 rounded-md text-sm cursor-pointer ${
              isSubmitting ? 'bg-gray-100 cursor-not-allowed' : 'hover:bg-gray-50'
            }`}
          >
            <FiUpload size={16} />
            {imagePreview ? 'Change Image' : 'Upload Image'}
          </label>
          <p className="text-xs text-gray-500 mt-1">
            Upload a high-quality image of your recipe (JPEG, PNG, or WebP)
          </p>
        </div>
      </div>
    </div>
  );
};

export default RecipeImageUpload;